import * as React from 'react'
import { Route } from 'react-router'
import { Switch } from 'react-router-dom'
import '../styles/App.scss'
import '../styles/App-media.scss'
import { NewAccountContainer } from './NewAccount'
import SetJobDetails from './SetJobDetails'
import { MuiThemeProvider, lightBaseTheme } from 'material-ui/styles'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { StartingPageContainer } from './StartingPage'
import { SignInContainer } from './SignIn'
import LocationSearchInput from '../components/LocationSearch'
import { ReviewHaulerContainer } from './ReviewHaulerContainer'
import { ViewBidsContainer } from './ViewBids'
import { LogOutContainer } from './LogOutContainer'
import PublishedJob from './PublishedJob'
import PickupLocation from './PickupLocation'
import { CompletedJobs } from './CompletedJobs'
import { ROUTES } from '../constants/routes'
import { StubComingSoon } from './StubComingSoon'
import BidAccepted from './BidAccepted'
import { AdditionalItems } from './AdditionalItems'
import { ForgotPasswordContainer } from './ForgotPassword'
import { PreferencesContainer } from './PreferencesContainer'
import { TermsContainer } from './Terms'
import { ContactUsContainer } from './ContactUs'
import { CompletedJobDetailedContainer } from './CompletedJobDetailedContainer'
import { SetAvailability } from './SetAvailability'
import { ChatContainer } from './Chat'
import { WaitingForAuthorizationContainer} from './WaitingForAuthorization'

const lightMuiTheme = getMuiTheme(lightBaseTheme)

export class Routes extends React.Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={lightMuiTheme}>
        <React.Fragment>
          <Switch>
            <Route
              exact={true}
              path={ROUTES.ROOT}
              component={StartingPageContainer}
            />
            <Route
              exact={true}
              path={ROUTES.SIGN_IN}
              component={SignInContainer}
            />
            <Route
              exact={true}
              path={ROUTES.PICKUP_LOCATION}
              component={PickupLocation}
            />
            <Route
              exact={true}
              path={ROUTES.COMPLETED_JOBS}
              component={CompletedJobs}
            />
            <Route
              exact={true}
              path={ROUTES.NEW_ACCOUNT}
              component={NewAccountContainer}
            />
            <Route
              exact={true}
              path={ROUTES.JOB_DETAILS}
              component={SetJobDetails}
            />
            <Route
              exact={true}
              path={ROUTES.PUBLISHED_JOB}
              component={PublishedJob}
            />
            <Route
              exact={true}
              path={ROUTES.WAITING_FOR_CARD_AUTHORIZATION}
              component={WaitingForAuthorizationContainer}
            />
            <Route
              exact={true}
              path={ROUTES.COMPLETED_JOB_DETAILED}
              component={CompletedJobDetailedContainer}
            />
            <Route
              exact={true}
              path={ROUTES.LOCATION_SEARCH}
              component={LocationSearchInput}
            />
            <Route
              exact={true}
              path={ROUTES.VIEW_BIDS}
              component={ViewBidsContainer}
            />
            <Route
              exact={true}
              path={ROUTES.BID_ACCEPTED}
              component={BidAccepted}
            />
            <Route
              exact={true}
              path={ROUTES.REVIEW_HAULER}
              component={ReviewHaulerContainer}
            />
            <Route
              exact={true}
              path={ROUTES.COMING_SOON}
              component={StubComingSoon}
            />
            <Route
              exact={true}
              path={ROUTES.LOG_OUT}
              component={LogOutContainer}
            />
            <Route
              exact={true}
              path={ROUTES.ADDITIONAL_ITEMS}
              component={AdditionalItems}
            />
            <Route
              exact={true}
              path={ROUTES.FORGOT_PASSWORD}
              component={ForgotPasswordContainer}
            />
            <Route
              exact={true}
              path={ROUTES.PREFERENCES}
              component={PreferencesContainer}
            />
            <Route
              exact={true}
              path={ROUTES.TERMS}
              component={TermsContainer}
            />
            <Route
              exact={true}
              path={ROUTES.CONTACT}
              component={ContactUsContainer}
            />
            <Route
              exact={true}
              path={ROUTES.SET_AVAILABITILY}
              component={SetAvailability}
            />
            <Route
              path={ROUTES.CHAT}
              component={ChatContainer}
            />
          </Switch>
        </React.Fragment>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Routes.tsx